import { IMApp, IMAppStatsListItem } from 'mappClient/models';
import { AppType } from 'mappClient/enums/core';
import { SelectClickable } from 'mappMvc/models/selection';
import { Localization } from 'mappMvc/compile';

export class MApp extends SelectClickable implements IMApp, IMAppStatsListItem {
	public name: string;
	public image: string;
	public appType: AppType;
    public roleIds: string[];
	public roles: string[];
    public isLegacyBrowserMapp: boolean;
    public bgClass: string;
    public roleLabel: KnockoutComputed<string>;
    public appTypeLabel: KnockoutComputed<string>;
    public appTypeDisplay: KnockoutComputed<string>;
    public iconClass: KnockoutComputed<string>;
    public hasStats: KnockoutComputed<boolean>;

	private appTypeConfig: {
		[key: string]: {
			gradient: string;
			name: string;
			icon: string;
			type: keyof typeof AppType;
		};
	};

    constructor(id: string, name: string, image: string, appType: AppType, roleIds: string[], roles: string[] = [], isLegacyBrowserMapp = false) {
		super({ id: id });

		this.name = name;
		this.image = image;
        this.appType = appType;
        this.roleIds = roleIds;
        this.roles = roles.sort(function (a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
		});
		this.isLegacyBrowserMapp = isLegacyBrowserMapp;

		this.appTypeConfig = {};
		this.appTypeConfig[AppType[AppType.Browser]] = {
			gradient: '181',
			name: Localization.Studio.Browser,
			icon: 'mapp-studio-icons-browser-streamline-window',
			type: "Browser"
		};
		this.appTypeConfig[AppType[AppType.Desktop]] = {
			gradient: '182',
			name: Localization.Studio.Desktop.Desktop,
			icon: 'mapp-studio-icons-screen-desktop',
			type: "Desktop"
		};
		this.appTypeConfig[AppType[AppType.Mobile]] = {
			gradient: '180',
			name: Localization.Studio.Mobile,
			icon: 'mapp-studio-icons-phone',
			type: "Mobile"
		};

		this.bgClass = this.image
			? ''
			: 'webgradients gr-'.concat(this.appTypeConfig[AppType[this.appType]].gradient);

		this.appTypeDisplay = ko.pureComputed(() => {
			return '  /  '.concat(this.appTypeConfig[AppType[this.appType]].name);
        });

        this.appTypeLabel = ko.pureComputed(() => {
            return AppType[this.appType];
        });

        this.roleLabel = ko.pureComputed(() => {
            return this.roles.join(', ');
        });

        this.hasStats = ko.pureComputed(() => {
            return this.appType != AppType.Mobile;
        });

		this.iconClass = ko.pureComputed(() => {
			return this.image ? '' : 'icon '.concat(this.appTypeConfig[AppType[this.appType]].icon).concat(` ${this.appTypeConfig[AppType[this.appType]].type}`);
		});
	}

	static deserialize(mappData: IMApp): MApp {
		// TODO: where are the roles (not roleIds) coming from?
		return new MApp(mappData.id, mappData.name, mappData.image, mappData.appType, mappData.roleIds, undefined, mappData.isLegacyBrowserMapp);
	}
}
